module.exports = __webpack_public_path__ + "img/botella_blanco.862f10e4.jpg";